import {includes, hashSum} from 'helpers';
import {AnyObject} from 'types';

export function notify(message: string, props: AnyObject = {}) {
  window.dispatchEvent(new CustomEvent('popuptoggle', {
    detail: {
      Component: () => message,
      id: hashSum(message),
      align,
      props,
      notification: true
    }
  }));
}

function align(popup: AnyObject) {
  return {
    ...popup,
    className: {
      notification: true,
      error: includes(popup.props.className, 'is-error'),
      alert: includes(popup.props.className, 'is-alert')
    }
  };
}
